export default {
  text_1_1: 'Tutorial',

  text_2_1: 'Tutorial de copia de seguridad',
  text_2_2: 'Tutorial de importación',
  text_2_3: 'Tutorial avanzado (función de pago)',

  text_3_1: 'Crear monedero',
  text_3_1_1: 'Después de seleccionar \'Crear monedero\', continúa con el proceso de copia de seguridad.',

  text_3_2: 'Copia de seguridad',
  text_3_2_1:
    'En la página de copia de seguridad, selecciona \'Copia de seguridad con KeyPal Card\'. Todo el proceso se divide en cuatro pasos: (1) establece un código PIN para tu KeyPal Card; (2) realiza la copia de tu frase de recuperación en tu KeyPal Card; (3) verifica la exactitud de tu copia de seguridad; (4) comienza a usarla.',
  text_3_2_2:
    'Toca \'Iniciar copia de seguridad\'. Se te pedirá introducir tu código PIN dos veces para evitar errores. El código PIN protege tu copia de seguridad y controla el acceso a la tarjeta. Nota: eres responsable de mantener seguro tu código PIN—¡por favor, recuérdalo!',
  text_3_2_3:
    'Después de configurar el código PIN, sigue las instrucciones para colocar la KeyPal Card sobre la cámara trasera del teléfono (el área de detección NFC). En iOS, establecer una conexión segura puede tardar unos segundos—este breve retraso es normal.',
  text_3_2_4:
    'Cuando finalice la detección y los datos sean correctos, tu frase de recuperación se cifrará y se escribirá en la KeyPal Card. Al terminar, la interfaz mostrará una confirmación.',
  text_3_2_5:
    'Después de la copia de seguridad, continúa con el paso final—la verificación de la copia. ¡Te recomendamos encarecidamente realizarla!',

  text_3_3: 'Verificar',
  text_3_3_1:
    'Sigue la guía de verificación para introducir el código PIN que configuraste previamente para tu KeyPal Card. Luego, acerca la tarjeta a la cámara trasera para la detección NFC.',
  text_3_3_2:
    'Si la verificación es correcta, verás un aviso. Para evitar filtraciones, la frase de recuperación se mostrará parcialmente oculta—sigue las indicaciones para revisar cada palabra.',
  text_3_3_3:
    'Tras la verificación, puedes tocar \'Siguiente\' para empezar a usarla. Para mejorar la versatilidad y la seguridad, también disponemos de la \'Función de pago\'—consulta el \'Tutorial de funciones avanzadas\' para más detalles.',

  text_3_4: 'Notas y precauciones',
  text_3_4_1:
    '1. TokenPocket no almacena tu código PIN. Por favor, recuérdalo y haz tu propia copia de seguridad.',
  text_3_4_2:
    '2. Cada KeyPal Card puede tener un PIN único. Si lo introduces de forma incorrecta 10 veces seguidas, todos los datos de la tarjeta se borrarán por completo.',
  text_3_4_3: '3. Recomendamos utilizar una KeyPal Card nueva para las copias de seguridad.',
  text_3_4_4:
    '4. Restablecer la KeyPal Card eliminará todos los datos de forma permanente e irreversible—¡asegúrate de entenderlo!',
  text_3_4_5:
    '5. En iOS, la copia de seguridad y el uso pueden ser más lentos—es normal, por favor, ten paciencia.',

  text_4_1: 'Tutorial de importación',
  text_4_2_1:
    'Con una KeyPal Card con copia de seguridad, puedes importar los monederos en TokenPocket. La importación admite red única y multirred; a continuación nos centramos en la importación multirred (similar a la de red única).',
  text_4_3_1:
    '1. Selecciona \'Importar monedero\', toca \'Monedero hardware KeyPal\', y luego elige KeyPal Card en la ventana emergente.',
  text_4_3_2:
    '2. Tras elegir KeyPal Card, toca \'Iniciar importación\' e introduce el PIN de la tarjeta.',
  text_4_3_3:
    '3. Tras introducir el PIN, aparecerá la página de escaneo. Acerca la tarjeta a la cámara trasera y toca \'Iniciar escaneo\' para comenzar la detección y lectura NFC. En iOS, esto puede tardar un poco—por favor, ten paciencia.',
  text_4_3_4:
    '4. Cuando la frase de recuperación se lea correctamente, se te notificará. Toca \'Siguiente\' para elegir redes y crear tu monedero. Para mayor versatilidad y seguridad, también ofrecemos la \'Función de pago\'—consulta el \'Tutorial de funciones avanzadas\' para más información.',

  text_4_4: 'Notas y precauciones',
  text_4_4_1:
    '1. En iOS, la copia de seguridad y el uso pueden ser más lentos—esto es normal.',
  text_4_4_2:
    '2. Nota: antes de leer tu tarjeta, debes introducir el PIN. Si el PIN se introduce incorrectamente 10 veces seguidas, la tarjeta borra automáticamente todos los datos; una vez introducido correctamente, el contador de errores se restablece a cero.',
  text_4_4_3:
    '3. Al usar la \'Función de pago\', la frase de recuperación no se almacena en tu teléfono. Cada transacción requiere escanear tu KeyPal Card para firmar.',

  text_5_1: 'Tutorial avanzado',
  text_5_2_1:
    'La función de pago aumenta la versatilidad y mantiene tu frase de recuperación y clave privada fuera de línea y más seguras (no se almacenan en tu teléfono).',
  text_5_3_1:
    '1. Durante la creación/importación, usa las Opciones avanzadas para evitar almacenar la frase de recuperación o la clave privada en el dispositivo. Después, escanea la tarjeta para firmar las transacciones.',
  text_5_3_2:
    '2. Cuando inicies una transferencia o una transacción de DApp, el panel mostrará \'Escanear tarjeta para pagar\'. Tócalo para iniciar el flujo de pago.',
  text_5_3_3:
    '3. Después de tocar, introduce el PIN de tu tarjeta para verificar la identidad.',
  text_5_3_4:
    '4. Luego coloca la tarjeta según las instrucciones para la lectura y la firma. Tras firmar, la transacción se envía a la cadena de bloques.',

  text_5_4: 'Notas y precauciones',
  text_5_4_1:
    '1. Antes de leer tu tarjeta, debes introducir el PIN. Diez fallos consecutivos borrarán todos los datos; una entrada correcta restablece el contador.',
  text_5_4_2:
    '2. Con la \'Función de pago\', la frase de recuperación nunca se almacena en tu teléfono—escanea la tarjeta cada vez para firmar.',
};
